import { createAction } from 'Helpers';
import packageTypes from './types';

const packageActions = {
	V2_fetchRequest: createAction(packageTypes.V2_FETCH.REQUEST),
	V2_fetchSuccess: createAction(packageTypes.V2_FETCH.SUCCESS),
	V2_fetchFailure: createAction(packageTypes.V2_FETCH.FAILURE),
	V2_fetchClear: createAction(packageTypes.V2_FETCH.CLEAR),

	V1_fetchRequest: createAction(packageTypes.V1_FETCH.REQUEST),
	V1_fetchSuccess: createAction(packageTypes.V1_FETCH.SUCCESS),
	V1_fetchFailure: createAction(packageTypes.V1_FETCH.FAILURE),
	V1_fetchClear: createAction(packageTypes.V1_FETCH.CLEAR),

	updateStatusRequest: createAction(packageTypes.UPDATE_STATUS.REQUEST),
	updateStatusSuccess: createAction(packageTypes.UPDATE_STATUS.SUCCESS),
	updateStatusFailure: createAction(packageTypes.UPDATE_STATUS.FAILURE),
	updateStatusClear: createAction(packageTypes.UPDATE_STATUS.CLEAR),

	createRequest: createAction(packageTypes.CREATE.REQUEST),
	createSuccess: createAction(packageTypes.CREATE.SUCCESS),
	createFailure: createAction(packageTypes.CREATE.FAILURE),
	createClear: createAction(packageTypes.CREATE.CLEAR),

	updateRequest: createAction(packageTypes.UPDATE.REQUEST),
	updateSuccess: createAction(packageTypes.UPDATE.SUCCESS),
	updateFailure: createAction(packageTypes.UPDATE.FAILURE),
	updateClear: createAction(packageTypes.UPDATE.CLEAR),

	getBestSellingRequest: createAction(packageTypes.BEST_SELLING.REQUEST),
	getBestSellingSuccess: createAction(packageTypes.BEST_SELLING.SUCCESS),
	getBestSellingFailure: createAction(packageTypes.BEST_SELLING.FAILURE),
	getBestSellingClear: createAction(packageTypes.BEST_SELLING.CLEAR),
};

export default packageActions;
